module.exports = __webpack_public_path__ + "static/media/LG_FilterTour_s1.1f22c548.gif";